import { ArnConnectorType } from '@arianee/arn-types';

export enum ArnConnectionStatus {
  disconnected = 'disconnected',
  connecting = 'connecting',
  signing = 'signing',
  authenticated = 'authenticated',
}
export interface ArnAuthStatus {
  connectionStatus: ArnConnectionStatus;
  /**
   * Wallet ID.
   */
  address: string | undefined;

  message?: string;
  signature?: string;
  aat?: string; // Arianee Access Token, if set message and signature are ignored

  connectorType: ArnConnectorType;
  connectorOpts?: any;
}
